// index.js
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./interviewAI/App";
import JobTemplateApp from "./jobTemplate/App";
import "./index.css";
import logo from "./jobTemplate/assets/assets/logos/favicon-32.png";
import SecondCameraRecorder from "./interviewAI/components/SecondCameraRecorder";
import {NotificationProvider} from "./interviewAI/NotificationContext";
import { ThemeProvider } from "./theme/ThemeContext";

// Set page title and favicon programmatically so it uses the bundled asset
if (typeof document !== 'undefined') {
  document.title = 'Viriqo Hires-AI Interview Platform';
  try {
    const head = document.getElementsByTagName('head')[0];
    let link = head.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = logo;
  } catch (e) {
    console.warn('Failed to set favicon', e);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <NotificationProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/interview" element={<App role="candidate" />} />
          <Route path="/admin/interview" element={<App role="admin" />} />
          <Route path="/*" element={<JobTemplateApp />} />
          <Route path="/record" element={<SecondCameraRecorder />} />
        </Routes>
      </BrowserRouter>
    </NotificationProvider>
  </ThemeProvider>
);
